module.exports = __webpack_public_path__ + "img/smartCandidateManagementProject.3f0558d9.png";